/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bubble area — not radius — is proportional to the size value.`)
};

const es_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El área de la burbuja — no el radio — es proporcional al valor de tamaño.`)
};

const de_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Blasenfläche — nicht der Radius — ist proportional zum Größenwert.`)
};

const nl_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het oppervlak van de bel — niet de straal — is evenredig met de groottewaarde.`)
};

const fr_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'aire de la bulle — et non le rayon — est proportionnelle à la valeur de taille.`)
};

const it_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'area della bolla — non il raggio — è proporzionale al valore della dimensione.`)
};

const pt_br2_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A área da bolha — não o raio — é proporcional ao valor de tamanho.`)
};

const pt_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A área da bolha — não o raio — é proporcional ao valor do tamanho.`)
};

const ja_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バブルの面積 — 半径ではなく — がサイズの値に比例します。`)
};

const zh_bubble_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`气泡面积——而非半径——与大小数值成比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_ex2", locale)
	if (locale === "en") return en_bubble_ex2(inputs)
	if (locale === "es") return es_bubble_ex2(inputs)
	if (locale === "de") return de_bubble_ex2(inputs)
	if (locale === "nl") return nl_bubble_ex2(inputs)
	if (locale === "fr") return fr_bubble_ex2(inputs)
	if (locale === "it") return it_bubble_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_ex2(inputs)
	if (locale === "pt") return pt_bubble_ex2(inputs)
	if (locale === "ja") return ja_bubble_ex2(inputs)
	return zh_bubble_ex2(inputs)
};